import type { LoaderFunctionArgs } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ params }: LoaderFunctionArgs) {
  const countryCode = params?.countryCode ?? "US";

  return json({ countryCode });
}

export default function PrivacyPolicyForCountryCode() {
  const { countryCode } = useLoaderData<typeof loader>();

  return (
    <div className={"rounded bg-[#141416] border border-[rgba(255,255,255,0.07)] p-4 text-[#f0f0f2]"}>
      <h3 className={"mb-4 text-center text-xl font-bold"}>Privacy Policy</h3>

      <p>
        We&rsquo;ve updated our Privacy Policy and improved our privacy
        practices so we can better safeguard your data. This website may also
        use cookies to personalize your experience. &nbsp;By continuing to use
        our website, you accept the terms of our updated Privacy Policy and
        Cookies.
        <br />
        <br />
        &zwj;
        <strong>
          Privacy Policy and Information Notice
          <br />
          &zwj;
          <br />
          &zwj;
        </strong>
        Thank you for visiting our website (&ldquo;Site&rdquo;)&nbsp;
        <a href="https://7qz.io/" target="_blank" rel="noreferrer">
          www.7qz.io
        </a>
        &nbsp;(7QZ) operated by{" "}
        <span>{`${
          countryCode === "ZA" ? "7qz PTY LTD" : "J50 Ventures LLC"
        }`}</span>{" "}
        (the &ldquo;Company&rdquo;) is committed to treating the personal and
        corporate information of our Site users, customers, and vendors with
        respect and sensitivity.
        <br />
        <br />
        We&rsquo;ve updated our Privacy Policy and improved our privacy
        practices so we can better safeguard your data. This Site also uses
        cookies to personalize your experience and target advertising. &nbsp;By
        continuing to use our Site, you accept the terms of this Privacy Policy,
        our Terms of Use, and our Cookies policy.
        <br />
        <br />
        This Privacy Policy (together with our Terms of Use and any other
        policies referenced) identifies how we will collect and process any
        personally identifiable information, such as your name, email, address,
        financial account information, etc., &nbsp;that we collect from you, or
        that you provide to us.
        <br />
        <br />
        If you are a resident of the European Economic Area (&ldquo;EEA&rdquo;),
        this Privacy Policy also outlines additional policies applicable to our
        collection and processing of your personal information.
        <br />
        <br />
        As our services evolve and we perceive the need or desirability of using
        your personal data collected in other ways, we may from time to time
        amend this Privacy Policy. &nbsp;The effective date appears at the end
        of this Privacy Policy. &nbsp;We encourage you to check our Site
        frequently to review the current Privacy Policy in effect and any
        changes that may have been made to it.
        <br />
        <br />
        &zwj;
        <strong>
          <em>
            By providing your Personal Data to us in any format (e.g., via
            email, telephone, fax, or in person) and/or continuing to use any of
            our services or visiting our Site you accept and consent to the
            practices described in this Privacy Policy and Information Notice.
          </em>
          <br />
          <br />
          1.&nbsp;
        </strong>
        <strong>WHAT PERSONAL DATA DOES THE COMPANY COLLECT?</strong>
        <br />
        We collect personal information that you enter on our Site or otherwise
        volunteer to us when you contact us to, among other things, make
        purchases or request information. &nbsp;You can choose not to provide
        certain information, but then you might not be able to take advantage of
        many of our features.For purposes of this Policy, &ldquo;
        <strong>Personal Data</strong>&rdquo; means information (whether stored
        electronically or in paper-based filing systems) relating to a living
        individual who can be identified from that data (or from that data and
        other information in our possession). Personal Data can be:
        <br />
        &bull;&nbsp;<em>factual</em>&nbsp;&ndash; such as a name, address,
        email, phone, or date of birth
        <br />
        &bull;&nbsp;<em>sensitive</em>&nbsp;&ndash; such as financial account
        information, protected health or medical details or information about
        your racial or ethnic origin, political opinions, religious or similar
        beliefs, physical or mental health or condition or sexual life; or
        <br />
        &bull;&nbsp;<em>opinion</em>&nbsp;&ndash; such as the results of a
        self-assessment test.
        <br />
        7QZ collects only that Personal Data that is relevant for the purposes
        for which the data is requested. &nbsp;7QZ does not use your Personal
        Data in any way that is incompatible with the purposes for which it was
        collected or for which you have consented.
        <br />
        <br />
        You can visit our Site without telling us who you are or revealing any
        Personal Data. &nbsp;But in some circumstances, we may ask you for and
        you may submit Personal Data, which may include:
        <br />
        <br />
        <strong>
          INFORMATION YOU GIVE US
          <br />
          &zwj;
        </strong>
        When you contact us through our Site, or by corresponding with us by
        phone, e-mail, or otherwise, or meet us at an 7QZ event, we may collect
        Personal Data including:
        <br />
        &bull; contact information, such as name, address, email, and phone;
        <br />
        &bull; financial information, such as credit card and account
        information collected when you purchase products or services;
        <br />
        &bull; identification information, such as gender and date of birth;
        <br />
        &bull; for those considering careers with 7QZ, professional personal
        information such as a resum&eacute; or C.V., salary history, education
        history, citizenship information, and position sought, as applicable.
        <br />
        &bull; for current or prospective affiliates, suppliers, and
        subcontractors, personal information such as social security number,
        federal tax ID number, or other relevant information, as applicable.
        <br />
        <br />
        When considering an individual for employment, additional Personal Data
        may be collected, as set forth in our Employee Privacy Policy.
        <br />
        <br />
        <strong>
          INFORMATION WE COLLECT ABOUT YOU
          <br />
          &zwj;
        </strong>
        When you visit our Site, our web server automatically collects and
        stores the following information:
        <br />
        &bull; Technical information, including the Internet protocol (IP)
        address used to connect your computer to the Internet, website address,
        browser type and version, time zone setting, browser plug-in types and
        versions, operating system and platform.
        <br />
        &bull; Information about your visit, including the full Uniform Resource
        Locators (URL), clickstream to, through and from our site (including
        date and time), pages on our Site you viewed; page response times,
        download errors, duration of page visits, page interaction information
        (such as scrolling, clicks, and mouse-overs), methods used to browse
        away from the page, and any phone number used to call our customer
        service number.
        <br />
        This information helps us improve our Site and facilitates your online
        experience when accessing our Site.
        <br />
        <br />
        <strong>
          INFORMATION WE RECEIVE FROM OTHER SOURCES
          <br />
          &zwj;
        </strong>
        This is information we receive about you from third parties who operate
        other Sites or services we use to provide our products and services to
        you. &nbsp; We work closely with third parties, including, for example,
        business partners, promoters, affiliates, and sub-contractors in
        technical, payment and delivery services, advertising networks,
        marketing analytics providers, promotions, and search information
        providers. &nbsp;We will notify you when we receive information about
        you from them and the purposes for which we intend to use that
        information.
        <br />
        <br />
        <strong>
          COOKIES
          <br />
          &zwj;
        </strong>
        Our Site uses cookies to personalize your experience and target
        advertising.
        <br />
        <strong>
          &zwj;
          <br />
          2.HOW DOES THE COMPANY USE PERSONAL DATA?
          <br />
          INFORMATION YOU GIVE TO US
          <br />
          &zwj;
        </strong>
        We will use this information:
        <br />
        &bull; to provide you with the information, products, and services that
        you request from us.
        <br />
        &bull; to carry out our obligations arising from any contracts entered
        into between you and us, or between you and our promoters, affiliates,
        or distributors;
        <br />
        &bull; to contact you in the future to provide you with information
        about other goods and services we offer, or that are offered by our
        affiliates or third-party vendors;
        <br />
        &bull; to notify you about changes to our service;
        <br />
        &bull; to comply with applicable laws and regulations.
        <br />
        &bull; for training purposes, quality assurance, and to record details
        about the products and services you order from us;
        <br />
        &bull; to make inquiries about you for credit reference purposes;
        <br />
        &bull; to perform data analyses (including anonymization and aggregation
        of Personal Data);
        <br />
        &bull; for prospective employees, to respond to your job application and
        process your CV.
        <br />
        <br />
        <strong>
          INFORMATION WE COLLECT ABOUT YOU. WE WILL USE THIS INFORMATION
        </strong>
        :
        <br />
        &bull; to administer our site and for internal operations, including
        troubleshooting, data analysis, testing, research, statistical, and
        survey purposes.
        <br />
        &bull; to improve our site to ensure that content is presented in the
        most effective manner for you and for your computer;
        <br />
        &bull; as part of our efforts to keep our site safe and secure.
        <br />
        <br />
        <strong>
          INFORMATION WE RECEIVE FROM OTHER SOURCES
          <br />
          &zwj;
        </strong>
        We will combine this information with information you give to us and
        information we collect about you. We will use this information and the
        combined information for the purposes set out above (depending on the
        types of information we receive).
        <br />
        <br />
        <strong>
          3.DO WE SHARE YOUR PERSONAL DATA WITH ANY THIRD PARTIES?
          <br />
          &zwj;
        </strong>
        We do not sell your Personal Data to any third parties. &nbsp;We partner
        with third parties to provide some of the services and products
        available on our Site and at our events. &nbsp;We sometimes disclose
        your Personal Data to those third parties, and they sometimes collect
        your Personal Data in the first instance and provide it to us. &nbsp;All
        such third parties use your Personal Data only on behalf of 7QZ and
        under the instructions of 7QZ on how your information may be used and
        processed. &nbsp;7QZ and our partners will use your Personal Data for
        limited purposes as specified in this Policy. &nbsp;7QZ takes reasonable
        steps to ensure these third parties use your Personal Data only for the
        purposes for which they have been engaged by 7QZ and that they agree to
        provide protections for your Personal Data that are no less protective
        than those set out in this Policy.
        <br />
        <br />
        By visiting our Site or attending our events and sharing your Personal
        Data, you agree that we have the right to share your personal
        information with selected third parties including:
        <br />
        &bull;&nbsp;
        <strong>
          <em>Sales</em>
        </strong>
        &nbsp;&ndash; business partners, promoters, affiliates, distributors,
        suppliers, and sub-contractors for the purpose of fulfilling requests
        from you to purchase goods and services from our Site or at our events.
        <br />
        &bull;&nbsp;
        <strong>
          <em>Marketing</em>
        </strong>
        &nbsp;&ndash; business partners, promoters, affiliates, distributors,
        suppliers, and sub-contractors for the purpose of direct marketing of
        goods and services that you may be interested in;
        <br />
        &bull;&nbsp;
        <strong>
          <em>Cloud services</em>
        </strong>
        &nbsp;&ndash; business partners, promoters, affiliates, distributors,
        suppliers, and sub-contractors that provide cloud storage services;
        <br />
        &bull;&nbsp;
        <strong>
          <em>Contractual performance</em>
        </strong>
        &nbsp;&ndash; business partners, promoters, affiliates, distributors,
        suppliers, and sub-contractors for the performance of any contract we
        enter into with you, or they enter with you on behalf of 7QZ;
        <br />
        &bull;&nbsp;
        <strong>
          <em>Web analytics</em>
        </strong>
        &nbsp;&mdash; analytic site. search engine providers site. Assist us in
        the improvement and optimization of our site.
        <br />
        <br />
        <strong>
          WE MAY ALSO DISCLOSE YOUR PERSONAL INFORMATION TO THIRD PARTIES IN THE
          FOLLOWING CIRCUMSTANCES:
          <br />
          &zwj;
        </strong>
        &bull; In the event that we sell or buy any business or assets, in which
        case we will disclose your Personal Data to the prospective seller or
        buyer of such business or assets as part of the purchase, transfer, or
        sale of services or assets;
        <br />
        &bull; If we sell all or substantially all of our assets to a third
        party, in which case personal information about our customers will be
        one of the transferred assets;
        <br />
        &bull; If we are under a duty to disclose or share your Personal Data in
        order to comply with any legal obligation, or in order to enforce or
        apply our&nbsp;
        <a
          href="https://app.7qz.io/terms-and-conditions"
          target="_blank"
          rel="noreferrer"
        >
          terms of use
        </a>
        &nbsp;and other agreements; or to protect the rights, property, or
        safety of us, our customers, or others.Whenever we share information
        with third parties, we will take steps to ensure that the third parties
        put in place adequate measures to safeguard your Personal Data, and they
        will be required to use any Personal Data for only the intended purpose
        for which it was shared.
        <br />
        <br />
        <strong>
          4.OUR STORAGE OF YOUR PERSONAL DATA
          <br />
          &zwj;
        </strong>
        7QZ uses reasonable and appropriate measures to protect your Personal
        Data from loss, misuse and unauthorized access, disclosure, alteration
        and destruction, taking into due account the risks involved in the
        processing undertaken and the nature of the Personal Data we collect.
        <br />
        <br />
        We will keep your personal data for as long as we need it, or as
        otherwise prescribed by law, for the purposes set out above. &nbsp;This
        period will vary depending on your interactions with us. &nbsp;We may
        also keep a record of correspondence with you (for example if you have
        made a complaint about a product) for as long as is necessary to protect
        us from a legal claim.
        <br />
        <br />
        You may unsubscribe from any of our online e-mail updates and marketing
        by following the unsubscribe instructions in the body of any e-mail
        message we have sent to you. &nbsp;We will take commercially reasonable
        steps to implement your unsubscribe requests promptly, but you may still
        receive promotional information from us by mail for up to 60 days, and
        up to 10 days for e-mail. &nbsp;You may also continue to receive
        information from those third parties to whom we have previously
        disclosed your Personal Data.
        <br />
        <br />
        Please note that when you unsubscribe from our marketing communications,
        we will keep a record of your email address to ensure we do not send you
        marketing emails in future.
        <br />
        <br />
        <strong>
          5.ACCESS TO OTHER WEBSITES
          <br />
          &zwj;
        </strong>
        Our Site may include links to and from other websites of our partner
        networks and affiliates. &nbsp;If you follow a link to any of these
        websites, please note that these websites are not covered by this
        Privacy Policy. &nbsp;We are not responsible for the privacy practices
        of any third parties or the content of linked sites although we do
        encourage you to read the applicable privacy policies and terms and
        conditions of such parties or websites. &nbsp;This Privacy Policy only
        applies to how 7QZ deals with your Personal Data, and it does not apply
        to any other company or any other company&rsquo;s websites even if you
        access them via our Site. &nbsp;Please check those websites&rsquo;
        policies before you submit any Personal Data to them.
        <br />
        <br />
        <strong>
          6.PROTECTING CHILDREN&rsquo;S PRIVACY
          <br />
          &zwj;
        </strong>
        We are strongly committed to protecting the safety and privacy of
        children who visit our Site. &nbsp;Our Site is not designed nor is it
        intended to be used by children under 13, and we &nbsp;do not knowingly
        collect personal information online from children under 13 and have
        adopted techniques to ensure compliance with this Privacy Policy and the
        Children&rsquo;s Online Privacy Protection Act of 1998
        (&ldquo;COPPA&rdquo;). &nbsp; Our Site includes content that we believe
        to be unsuitable for children under 13, and we encourage all parents to
        talk to their children about online safety and to monitor their
        children&rsquo;s use of the Internet.
        <br />
        <br />
        <strong>
          7. ADDITIONAL POLICIES IN COMPLIANCE WITH THE EEA PRIVACY LAWS
          <br />
          &zwj;
        </strong>
        In addition to the other policies described in this Privacy Policy,
        residents of the European Union or the EEA are afforded the following
        additional rights and protections as required by the General Data
        Privacy Regulation (&ldquo;GDPR&rdquo;). &nbsp;The additional rights and
        protections set forth in this section of this Policy apply only to
        residents of the European Union or the EEA.
        <br />
        <br />
        <strong>
          7.1 GDPR DEFINITIONSTHE FOLLOWING ADDITIONAL DEFINITIONS APPLY TO THIS
          SECTION OF THE PRIVACY POLICY:
          <br />
          &zwj;
        </strong>
        &ldquo;<strong>Controller</strong>&rdquo; means the Company which is the
        organization that determines the purposes for which, and the manner in
        which, any Personal Data is Processed and used in its business.
        <br />
        &ldquo;<strong>Processor</strong>&rdquo; means any Person Processing
        Personal Data.
        <br />
        &ldquo;<strong>Person</strong>&rdquo; means a natural person,
        corporation, association, organization, partnership, or other legal
        entity.
        <br />
        &ldquo;<strong>Processing</strong>&rdquo; is any activity that involves
        use of Personal Data. It includes, without limitation, obtaining,
        recording or holding Personal Data, or carrying out any operation or set
        of operations on the Personal Data including organizing, amending,
        retrieving, using, disclosing, erasing or destroying it. Processing also
        includes Personal Data to third parties.
        <br />
        <br />
        <strong>
          7.2 THE LEGAL BASIS FOR PROCESSING YOUR PERSONAL DATA
          <br />
          &zwj;
        </strong>
        In order to comply with the GDPR, we are required to set out the legal
        basis for the processing of your Personal Data. &nbsp;In accordance with
        the purposes for which we collect and use your Personal Data, as set out
        above, the legal basis for processing your Personal Data will typically
        be one of the following:
        <br />
        &bull; our own legitimate business interests, or the legitimate business
        interests of our third party partners, promoters, affiliates,
        distributors, suppliers, vendors, and subcontractors, such as, for
        example, providing direct marketing to our customers of our products and
        services that we think would be of interest, permitting prospective
        employees to search and apply for job opportunities, handling inquiries
        from our promoters, affiliates, distributors, vendors, and customers, or
        other instances where we have a legitimate interests assessment and have
        established an existing legitimate interest;
        <br />
        &bull; the performance of a contract that we have in place with you.
        <br />
        &bull; your consent where appropriate; or
        <br />
        &bull; compliance with our legal obligations, including to meet national
        security or law enforcement requirements.
        <br />
        <br />
        <strong>
          7.3 WHERE WE STORE YOUR PERSONAL DATA
          <br />
          &zwj;
        </strong>
        The data that we collect from you is stored on our servers or on servers
        provided by cloud service providers, such as Amazon Web Services/and or
        hosting by GoDaddy. &nbsp;If you are a resident of the EEA, your
        Personal Data may be transferred within or outside the EEA to areas
        where privacy laws may be less strict than in the EEA. &nbsp;By
        submitting your Personal Data, you agree to this transfer, storing, and
        processing. &nbsp;We will take all steps reasonably necessary to ensure
        that your data is treated securely and in accordance with this Privacy
        Policy.
        <br />
        <br />
        Unfortunately, the transmission of information via the Internet is not
        completely secure. Although we will do our best to protect your Personal
        Data, we cannot guarantee the security of your data transmitted to our
        site; any transmission is at your own risk. &nbsp;Once we have received
        your information, we will use strict procedures and security features to
        try to prevent unauthorized access.
        <br />
        <br />
        <strong>
          7.4 ADDENDUM TO HOW LONG WE STORE YOUR PERSONAL DATA
          <br />
          &zwj;
        </strong>
        In some cases, there is a legal requirement to keep Personal Data for a
        minimum period of time. &nbsp;Except in those circumstances, we do not
        keep your Personal Data for any longer than is necessary for the
        purposes for which the Personal Data was collected or for which it is to
        be further processed.
        <br />
        <br />
        <strong>
          7.5 YOUR RIGHTS WITH RESPECT TO YOUR PERSONAL DATA
          <br />
          &zwj;
        </strong>
        Subject to certain exceptions, you have the following rights with
        respect to your Personal Data:
        <br />
        &bull; To receive a copy of the Personal Data that we hold about you;
        <br />
        &bull; To request that any inaccurate or incomplete Personal Data be
        corrected or supplemented;
        <br />
        &bull; To have your Personal Data erased, unless we have a legitimate
        reason to retain the Personal Data (such as if we are required to do so
        for legal reasons); and
        <br />
        &bull; To ask us not to process your Personal Data for a particular
        purpose, including for marketing.
        <br />
        <br />
        All of these rights are subject to certain conditions and exemptions.
        &nbsp;For example, 7QZ will not be obligated to erase your Personal Data
        if we need to retain it to protect ourselves in the event of a legal
        claim.
        <br />
        <br />
        To exercise any of these rights, &nbsp;please submit a written request
        to us using the contact information set forth&nbsp;
        <a
          href="https://app.7qz.io/privacy-policy"
          target="_blank"
          rel="noreferrer"
        >
          below
        </a>
        . The Company reserves the right to charge a fee for dealing with such a
        request as permitted by applicable law and regulations. &nbsp;You may
        also opt out of receiving additional marketing information by using the
        unsubscribe feature in any marketing email we send you.
        <br />
        <br />
        <strong>
          8. CONDITIONS OF USE AND CHANGES TO OUR PRIVACY POLICY
          <br />
          &zwj;
        </strong>
        If you choose to visit our Site and attend our events, your visit and
        any dispute over privacy is subject to this Notice and our Terms of Use,
        including limitations on damages, resolution of disputes, and
        application of the law of the State of California. &nbsp;If you have any
        concern about our privacy practices, please contact us with a thorough
        description, and we will try to resolve it. &nbsp;As our business
        changes, our Privacy Policy and Terms of Use may change also. We may
        e-mail periodic reminders of our notices and conditions, but you should
        check our Site frequently to see recent changes. &nbsp;Unless stated
        otherwise, our current Privacy Policy applies to all information that we
        have about you and your account.
        <br />
        <br />
        <strong>
          9.CONTACTING US
          <br />
          &zwj;
        </strong>
        This Site is owned and operated by J50 VENTURES LLC. &nbsp;If you have
        any questions or suggestions with respect to this Privacy Policy or our
        privacy practices, please e-mail us at&nbsp;
        <a href="mailto:info@7qz.io" target="_blank" rel="noreferrer">
          info@7qz.io
        </a>
        , or you can contact us by mail at:
        <br />
        &zwj;
        <strong>
          {`${countryCode === "ZA" ? "7qz PTY LTD" : "J50 VENTURES LLC"}`}
          <br />
          {`${countryCode === "ZA" ? "3 Loquat Place" : "468 N. Camden Drive"}`}
          <br />
          {`${
            countryCode === "ZA"
              ? "Constantia, Cape Town"
              : "Beverly Hills, CA 90210"
          }`}
          <br />
          <br />
        </strong>
        Updated March 27<sup>th</sup>, 2023
      </p>
    </div>
  );
}
